<template>
  <div
    id="sideMenu"
    class="bg-secondary bg-opacity-25 text-dark p-3 gl-sidebar"
  >
    <h3>Servers</h3>
    <ul class="list-group">
      <li class="list-group-item list-group-item-action">
        <a href="http://coronavirus3d.org" target="_blank">Coronavirus3D</a>
      </li>

      <li class="list-group-item list-group-item-action">
        <a href="http://modflex.org" target="_blank">ModFlex</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://xtalpred.godziklab.org" target="_blank">XtalPred</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://ffas.godziklab.org" target="_blank">FFAS</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://fatcat.godziklab.org" target="_blank">FATCAT</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://posa.godziklab.org" target="_blank">POSA</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://cancer3d.org" target="_blank">Cancer3D</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://pdbflex.org" target="_blank">PDBflex </a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://console.godziklab.org" target="_blank">ConSole</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://aida.godziklab.org" target="_blank">AIDA </a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://protael.org" target="_blank">Protael</a>
      </li>
      <!-- 
      <li class="list-group-item list-group-item-action">
        <a href="http://pubserver.godziklab.org/" target="_blank">PubServer</a>
      </li> -->
      <!-- <li class="list-group-item list-group-item-action">
        <a href="http://godziklab.org/DomainGraph" target="_blank">CADO</a>
      </li> -->
      <li class="list-group-item list-group-item-action">
        <a href="http://protmod.godziklab.org" target="_blank">ProtMod</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <router-link to="servers" title="Servers">more ...</router-link>
      </li>
    </ul>
    <h3 class="mt-4">Resources</h3>
    <ul class="list-group">
      <li class="list-group-item list-group-item-action">
        <a href="http://godziklab.org/JCMM">JCMM</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://godziklab.org/SSBC/modeling.html" target="_blank"
          >Protein Modeling Tutorial</a
        >
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://transportPDB.org" target="_blank">Transport PDB</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="http://cd-hit.org" target="_blank">CD-HIT</a>
      </li>
      <!-- <li class="list-group-item list-group-item-action">
        <a href="/webcal">Lab Calendar</a>
      </li> -->
      <li class="list-group-item list-group-item-action">
        <a href="https://github.com/GodzikLab" target="_blank">Lab Github</a>
      </li>
      <li class="list-group-item list-group-item-action">
        <a
          href="https://docs.google.com/spreadsheets/d/1YXlC_jHDEl5W5BrCf7d1q9W5DLJBEoB6-4A3mvAW-tw/edit?ts=5c94125d#gid=0"
          target="_blank"
          >Lab Meetings</a
        >
      </li>
      <li class="list-group-item list-group-item-action">
        <a href="https://stats.uptimerobot.com/8EAAjC0rX" target="_blank"
          >Server Status</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>